import React, { ReactElement, useState } from "react";
import styles from "./styles.module.scss"
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { subscribeToLiveUpdatetChannel, websocket } from "services/socketServices";
import setLanguage from "services/i18n";
import { setLang } from "redux/auth/authSlice";
import { getConfigRequested, getPalimpsestRequested } from "redux/sport/sportSlice";
import { Translate } from "react-redux-i18n";

interface IProps {
  handleClose: () => void
}

interface LanguageOption {
  locale: string;
  header: string;
}

export default function LanguageSwitch({ handleClose }: IProps): ReactElement {
  const dispatch = useAppDispatch()
  const locale = useAppSelector((state) => state.auth.locale);

  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const images = require.context(
    "assets/images/flags",
    true,
    /\.(png|ico|svg|jpg|gif)$/
  );

  const handleChange = (event: string) => {
    const langConfig = process.env.REACT_APP_LANGUAGE_OPTIONS;
    const jsonConfig = langConfig && JSON.parse(langConfig);
    const oldLang = jsonConfig.find(
      (el: Record<string, string>) => el.locale === locale
    ).header;
    websocket.leaveChannel(`live.update.${oldLang}`);

    setLanguage(event);
    dispatch(setLang(event));
    dispatch(getConfigRequested());
    dispatch(getPalimpsestRequested());

    const newLang = jsonConfig.find(
      (el: Record<string, string>) => el.locale === event
    ).header;
    subscribeToLiveUpdatetChannel(newLang)
    handleClose()
  }

  return (
    <Accordion expanded={isExpanded} className={styles.languageAccordion}>
      <AccordionSummary onClick={() => setIsExpanded(!isExpanded)} className={styles.accordionSummary}>
        <Box className={styles.summaryContainer}>
          <Typography className={styles.accordionLabel}><Translate value="languageSwitch.language" /></Typography>
          <img src={images(`./${locale}.svg`).default} alt="" height="15px" />
        </Box>
      </AccordionSummary>
      <AccordionDetails className={styles.accordionDetails}>
        {
          process.env.REACT_APP_LANGUAGE_OPTIONS &&
          JSON.parse(process.env.REACT_APP_LANGUAGE_OPTIONS).map((option: LanguageOption) =>
            <Box
              key={option.locale}
              onClick={() => handleChange(option.locale)}
              className={`
              ${styles.singleLanguage} 
              ${locale === option.locale && styles.selected}
              `}
            >
              <img src={images(`./${option.locale}.svg`).default} alt="" height="17px" />
              <Typography className={styles.label}>{option.locale}</Typography>
            </Box>
          )
        }
      </AccordionDetails>
    </Accordion>
  )
}